import { UserService } from '@user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ModuleService } from '@module/module.service';
import { ICompany } from '@company/company.structures';
import { IDialogData, IUser, User, IModule, ITableauWorkbook, IErrorResponse } from '@interfaces';
import { ExceptionService } from '@exceptions-service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';

import { AppService } from '@base/app.service';
import { environment } from '@environments/environment';

import { DialogComponent } from '@dialog/dialog.component';
import { ROLES, COMPANY, MODULE, UNDEFINED, EMPTY, MODULE_TAGS } from '@utils';
import { BehaviorSubject, Subscription, } from 'rxjs';
import { IHomeDataSet } from './home.resolver';
import { CompanyService } from '@company/company.service';
import { WorkbookService } from '@workbook/workbook.service';
import { TableauService } from '@tableau/tableau.service';
// import { faRan, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faRandom, faFilter } from '@fortawesome/free-solid-svg-icons';

interface ICompanyInfo {
  name: string;
  companyName: string;
  pathLogo: string;
  version: number;
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit, OnDestroy {
  ADMINISTRATORS = ROLES.ADMIN;
  LEADERS = ROLES.LEADER;
  ANALYSTS = ROLES.ANALYST;
  CUSTOMERS = ROLES.CUSTOMER;
  private _mobileQueryListener: () => void;
  private subscriptions: Subscription[];
  private workbooks: ITableauWorkbook[];
  private tableauWorkbooks: ITableauWorkbook[];
  private activeCompany: ICompany;

  mobileQuery: MediaQueryList;
  activeMenu: string;
  env = environment;
  session: IUser;
  sessionData = new BehaviorSubject<Partial<IUser>>({});
  data = this.sessionData.asObservable();
  sessions = [];
  menuDict = [
    {code: 'home', description: 'dashboard'},
    {code: ROLES.ADMIN, description: 'administradores'},
    {code: ROLES.LEADER, description: 'líderes'},
    {code: ROLES.ANALYST, description: 'analistas'},
    {code: ROLES.CUSTOMER, description: 'clientes'},
    {code: COMPANY, description: 'empresas'},
    {code: 'roles', description: 'roles'},
    {code: MODULE, description: 'módulos'},
    {code: 'settings', description: 'Parámetros'},
    {code: 'roles', description: 'Roles'},
  ];

  companyInfo: ICompanyInfo;
  mainCompanyInfo: ICompanyInfo;
  companies: ICompany[];
  modules: IModule[];
  companyModules: [];
  openedSideNav: boolean;
  faRandom = faRandom;
  faFilter = faFilter;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public mainService: AppService,
    private exceptionService: ExceptionService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private moduleService: ModuleService,
    private tableauService: TableauService,
    private workbookService: WorkbookService,
    private userService: UserService,
  ) {
    // isDevMode()
    this.session = new User();
    this.subscriptions = [];
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.activeMenu = this.menuDict[0]['description'];
    this.mainCompanyInfo = environment.platformInfo;
    this.companyInfo = environment.platformInfo;
    this.companies = [];
    this.modules = [];
    this.companyModules = [];
    this.workbooks = [];
    this.tableauWorkbooks = [];
    this.activeCompany = EMPTY;
    this.openedSideNav = false;
  }

  ngOnInit(): void {
    // suscripciones al cambio de usuario y cambio de lista de sesiones (login as)
    // escuchar cambios de usuarios y de empresas
    // actualizar el store de todos...
    const currentRouteSubscription = this.route.data.subscribe(
      (response) => {
        const data: IHomeDataSet = response['data'];

        if (data !== null) {
          this.mainService.setCurrentUser(data.user);
          this.mainService.setCurrentCompany(data.company);
          this.loadCustomerTags(data.user, data.company);
          this.companyService.getCompanies(data.user);
        } else {
          this.router.navigate(['']);
        }
      },
      (e: HttpErrorResponse) => {const err: IErrorResponse = this.exceptionService.errorHandling(e); }
    );

    this.route.params.subscribe(params => {
      // this.id = +params['id']; // (+) converts string 'id' to a number
      // In a real app: dispatch action to load the details here.
   });

    // suscripcion escuchando cambios en de USUARIOS...
    const currentUserSubscription = this.mainService.getCurrentUser().subscribe(
      (res: IUser) => {
        this.session = res;

        // mostrar el snackbar solo cuando haga LOGIN_AS...
        const fullName = `${res.first_name} ${res.last_name}`;
        if ((fullName.trim().length > 0) && (this.sessions.length > 0)) {
          this.mainService.isLoginAs = true;
          this.openSnackBar(`Logueado como ${res.first_name} ${res.last_name}`, 'info');
        }

        const loadCompanyInfo = (res.role['code'] === ROLES.ADMIN ||
          res.role['code'] === ROLES.LEADER || res.role['code'] === ROLES.ANALYST);
        if (loadCompanyInfo) {
          this.companyInfo = environment.platformInfo;
          this.openedSideNav = true;
        } else {
          this.openedSideNav = false;
        }
      },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    // suscripcion escuchando cambios de EMPRESA SELECCIONADA
    const currentCompanySubscription: Subscription = this.mainService.getCurrentCompany()
    .subscribe(
      (company: ICompany) => {
        this.activeCompany = company;
        let activeCompany = EMPTY;

        // es null cuando la sesion es admin o lider o analista...
        if (company !== null) {
          const modules = [...company.modules] as [];
          const arrayModules = modules.filter(e => e);
          activeCompany = (company !== null) ? {
            name: company.name,
            pathLogo: company.image_url,
            backgroundColor: company.color
          } : null;
          this.activeMenu = '';

          if (modules.length) {
            const customerModules = modules.filter((m: IModule) => !m.only_admin) ;
            this.companyModules = customerModules as [];
            this.activeMenu = arrayModules[0]['name'];
          }
        }

        this.companyInfo = (activeCompany !== null) ? activeCompany : this.companyInfo;
      },
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    // suscripcion escuchando cambios de EMPRESAS PERMITIDAS AL USUARIO
    const currentCompaniesSubscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => {this.companies = companies; },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    // suscripcion escuchando cambios de SESIONES... (login as)
    const sessionsSubscription = this.mainService.getSessions().subscribe(
      res => this.sessions = res,
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    const refreshTokenSubscription = this.mainService.observeTokenChanges()
    .subscribe(
      res => {
        if (typeof res !== UNDEFINED) {
          console.log('--PASO--');
          // this.mainService.refreshTokenAgain = true;
          // console.log('home', this.mainService.refreshTokenAgain);
          // this.mainService.setNewToken(res);
        }
      },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    // suscripcion escuchando MODULOS
    const modulesSubscription = this.moduleService.observeModules().subscribe(
      (modules: IModule[]) => {this.modules = modules; },
      (err) => console.error(`Ocurrio un error: ${err.message}`)
    );

    // suscripcion escuchando WORKBOOKS desde la BD
    const workbooksSubscription = this.workbookService.observeWorkbooks().subscribe(
      (workbooks: ITableauWorkbook[]) => {this.workbooks = (workbooks.length > 0) ? workbooks : []; },
      (err) => console.error(`Ocurrio un error: ${err.message}`)
    );

    // suscripcion escuchando WORKBOOOKS desde TABLEAU SERVER
    const tableauWorkbooksSubscription = this.tableauService.observeWorkbooks().subscribe(
      (workbooks: ITableauWorkbook[]) => { this.syncTableauWorkbooksIntoDB(workbooks); },
      (err) => console.error(`Ocurrio un error: ${err.message}`)
    );

    // almacenar las suscripciones
    this.subscriptions = [...this.subscriptions,
      currentUserSubscription, sessionsSubscription, currentCompanySubscription,
      currentRouteSubscription, currentCompaniesSubscription, refreshTokenSubscription,
      modulesSubscription, tableauWorkbooksSubscription, workbooksSubscription,
    ];
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);

    // borrar las suscripciones para evitar perdida de memoria
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());

    // para que no vuelva a cargar el logo ni la info de la empresa actual en el proximo login
    this.mainService.temp['company'] = undefined;

    // para que no continue haciendo peticiones para refrescar el token...
    this.mainService.refreshTokenAgain = false;
  }

  logoutUser(): void {
    const params: IDialogData = {
      strQuestion: `¿Confirma que desea salir de la aplicación?`,
      strAccept: 'Aceptar',
      strCancel: 'Cancelar',
      buttonColor: 'warn',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '370px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(exit => {
      if (exit) {
        this.userService.clearWorkbooks();
        localStorage.clear();
        this.router.navigate(['']);
      }
    });
  }

  switchMenu(strMenuName: string = 'home'): void {
    let route = '';
    this.activeMenu = strMenuName;
    const foundMenu = this.menuDict.filter((menu) => {
      return menu.code === strMenuName;
    });

    if (foundMenu.length) {
      const targetRoute = (foundMenu[0]['code'] === 'home') ? '' : foundMenu[0]['code'];
      route = `/home/${targetRoute}`;
      this.activeMenu = foundMenu[0]['description'];
      this.router.navigate([route]);
    }
  }

  openSnackBar(message: string, action: string, duration: number = 4000): void {
    try {
      this.snackBar.open(message, action, {
        verticalPosition: 'top',
        horizontalPosition: 'right',
        duration: duration,
      });
    } catch (error) { console.log(error); }
  }

  backPreviousSession() {
    localStorage.removeItem('company');
    this.mainService.removeSession();
    this.router.navigate(['/home/']);
  }

  private loadCustomerTags(user: IUser, company: ICompany) {
    // cargar los tags permitidos al cliente logueado...
    if (user.role['code'] === ROLES.CUSTOMER) {
      this.userService.loadTagsAllowed(user, company);
    }
  }

  changeCompany(company: ICompany) {
    this.loadCustomerTags(this.session, company);
    localStorage.setItem('company', JSON.stringify(company));
    this.userService.getWorkbooks(this.session, company);
    this.mainService.setCurrentCompany(company);
    this.router.navigate(['/home/panels/tableau']);
  }

  loadModuleInfo(module: IModule) {
    const moduleFilterParams = {
      moduleId: module.id,
      userId: (this.session.role['code'] === ROLES.ANALYST) ? this.session.id : 0,
    };
    this.activeMenu = `Vincular ${module.name}`;
    this.moduleService.setCurrentModule(module);
    this.moduleService.filterCompanies(moduleFilterParams).subscribe(
      (companies: ICompany[]) => {
        this.moduleService.setCompanies(companies);
        this.router.navigate(['/home/modules/', module.id]);
      }
    );
  }

  private syncTableauWorkbooksIntoDB(tableauWorkbooks: ITableauWorkbook[]) {
    this.tableauWorkbooks = tableauWorkbooks;
  }

  showModuleContent(module) {
    if (module['tableau_synchronize'] === true && module['tag'] === MODULE_TAGS.TABLEAU) {
      this.workbookService.setStatusProcessingData(false);
      this.workbookService.setWorkbook(EMPTY);
      this.activeMenu = module.name;
      this.router.navigate(['/home/panels/tableau']);
    } else {
      this.openSnackBar(`El módulo ${module.name} no está disponible`, 'info');
    }
  }
}
